import { ChangeDetectorRef, Component, ElementRef, Inject, OnDestroy, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Cinema } from '../../../models/cinema';
import { CinemaService } from '../../../services/cinema.service';
import { CinemaDetalheModalComponent } from '../cinema-detalhe-modal/cinema-detalhe-modal.component';

@Component({
  selector: 'app-cinema',
  templateUrl: './cinema.component.html',
  styleUrls: ['./cinema.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class CinemaComponent implements OnInit, OnDestroy {

  filmes: Cinema[] = [];
  filmesFiltrados: Cinema[] = [];
  termoPesquisa = '';

  @ViewChild('masonryGrid') masonryGridElem!: ElementRef<HTMLDivElement>;
  private msnry!: Masonry;

  constructor(
    private cinemaService: CinemaService,
    private modalService: NgbModal,
    private cdRef: ChangeDetectorRef,
    @Inject('BASE_URL') private baseUrl: string,
  ) { }

  ngOnInit(): void {
    this.cinemaService.getAll().subscribe(res => {
      this.filmes = res;
      this.filmesFiltrados = res;

      this.cdRef.detectChanges();
      this.initMasonry();
    });
  }

  pesquisar(): void {
    const termo = this.termoPesquisa.trim().toLowerCase();

    this.filmesFiltrados = !termo
      ? this.filmes
      : this.filmes.filter(f =>
        f.titulo?.toLowerCase().includes(termo) ||
        f.elenco?.toLowerCase().includes(termo) ||
        f.direcao?.toLowerCase().includes(termo)
      );

    this.cdRef.detectChanges();

    setTimeout(() => this.initMasonry(), 0);
  }

  initMasonry(): void {
    if (this.masonryGridElem && this.masonryGridElem.nativeElement) {
      imagesLoaded(this.masonryGridElem.nativeElement, () => {
        if (this.msnry) {
          this.msnry.reloadItems();
          this.msnry.layout();
        } else {
          this.msnry = new Masonry(this.masonryGridElem.nativeElement, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer',
            percentPosition: true,
            gutter: 0,
          });
        }
      });
    }
  }

  onImageLoad(): void {
    if (this.msnry) {
      setTimeout(() => this.msnry.layout(), 100);
    }
  }

  handleMissingImage(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    imgElement.style.display = 'none';

    if (this.msnry) {
      setTimeout(() => this.msnry.layout(), 50);
    }
  }

  getImagemUrl(fileServerName?: string): string {
    if (!fileServerName) return '';

    if (/^https?:\/\//i.test(fileServerName)) return fileServerName;

    const normalizedBaseUrl = this.baseUrl.endsWith('/') ? this.baseUrl : `${this.baseUrl}/`;
    return `${normalizedBaseUrl}uploads/cinema/${fileServerName}`;
  }

  abrirDetalhe(filme: Cinema): void {
    const modalRef = this.modalService.open(CinemaDetalheModalComponent, {
      size: 'lg',
      centered: true
    });

    modalRef.componentInstance.filme = filme;
  }

  ngOnDestroy(): void {
    if (this.msnry) {
      this.msnry.destroy();
    }
  }
}
